import { ConfirmationDialog } from "../../common/ConfirmationDialog";
import { useState } from 'react';
import { Toggle } from 'office-ui-fabric-react';
import './ProjectSetBaselineConfirmation.css';

type Props = {
    onConfirm: (setProjectBaseline: boolean, setTasksBaseline: boolean, setKeyDatesBaseline: boolean) => void;
    onDismiss: () => void;
}

const ProjectSetBaselineConfirmation = (props: Props) => {
    const [updateProjectBaseline, setUpdateProjectBaseline] = useState<boolean>(true);
    const [updateTasksBaseline, setUpdateTasksBaseline] = useState<boolean>(false);
    const [updateKeyDatesBasline, setUpdateKeyDatesBasline] = useState<boolean>(false);

    return <ConfirmationDialog
        onYes={() => props.onConfirm(updateProjectBaseline, updateTasksBaseline, updateKeyDatesBasline)}
        onDismiss={props.onDismiss}
        yesButtonProps={{ text: "Confirm", disabled: !updateProjectBaseline && !updateTasksBaseline && !updateKeyDatesBasline }}
        dialogContentProps={{
            title: 'Set Project Baseline'
        }}
    >
        <div className="subenity-baseline-toggle">
            <div className="inline-toggle-wrap">
                <div>
                    <div className="label">Set baselines for the project start and finish dates</div>
                    <p>The baseline will be set for the project’s Start Date and Finish Date fields.</p>
                </div>
                <Toggle checked={updateProjectBaseline} onChange={(e, checked: boolean) => setUpdateProjectBaseline(checked)} />
            </div>
        </div>
        <div className="subenity-baseline-toggle">
            <div className="inline-toggle-wrap">
                <div>
                    <div className="label">Set baselines for all tasks in PPM Express schedule</div>
                    <p>Baseline will be created for the following fields in all tasks in PPM Express schedule: Start Date, Due Date, Duration, Effort, Original Estimate.</p>
                </div>
                <Toggle checked={updateTasksBaseline} onChange={(e, checked: boolean) => setUpdateTasksBaseline(checked)} />
            </div>
        </div>
        <div className="subenity-baseline-toggle">
            <div className="inline-toggle-wrap">
                <div>
                    <div className="label">Set baselines for all key dates</div>
                    <p>Baseline will be created for the Date field in all Key Dates.</p>
                </div>
                <Toggle checked={updateKeyDatesBasline} onChange={(e, checked: boolean) => setUpdateKeyDatesBasline(checked)} />
            </div>
        </div>
    </ConfirmationDialog>
}

export default ProjectSetBaselineConfirmation;